module.exports = __webpack_public_path__ + "img/pipe.4e0ea826.svg";